export var TOKEN_KEY = 'token';
export var USER_KEY = 'user';